import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Typography } from "@mui/material";
import { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { getClinicBranches } from "../../../redux/reducers/clinicSlice";
import { AppColors } from "../../../util/AppColors";
import "./GlobalSettings.css";

const SETTINGS_MENU = [
  {
    label: "General & Data Sharing",
    path: "/settings/general-data-sharing",
  },
  {
    label: "Billing & Finance",
    path: "/settings/billing-finance",
  },
  // {
  //   label: "Workbook Settings",
  //   path: "/settings/workbook-settings",
  // },
  {
    label: "Consultation Settings",
    path: "/settings/consultation-settings",
  },
  {
    label: "Inventory",
    path: "/settings/inventory",
  },
  // {
  //   label: "Communication",
  //   path: "/settings/communication",
  // },
  {
    label: "Roles & Permissions",
    path: "/settings/roles-permissions",
  },
  // {
  //   label: "Leave & Attendance",
  //   path: "/settings/leave-attendance",
  // },
  // {
  //   label: "Audit Log",
  //   path: "/settings/audit-log",
  // },
];

const GENERAL_DATA_SHARING_PATH = "/settings/general-data-sharing";

const GlobalSettingsLayout = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const clinicDet = useSelector((state) => state?.clinic?.details);
  const branches = useSelector((state) => state?.clinic?.branches);
  const user = localStorage.getItem("user");
  const role = localStorage.getItem("role");
  const profile = useMemo(() => {
    try {
      return user ? JSON.parse(user) : {};
    } catch {
      return {};
    }
  }, [user]);

  useEffect(() => {
    if (!branches?.length) {
      dispatch(getClinicBranches());
    }
  }, [branches?.length, dispatch]);

  const canShowGeneralDataSharing =
    role === "ROLE_ADMIN" ||
    branches?.some((li) => li?.id === profile?.id && !li?.branchNumber);

  const visibleMenu = useMemo(
    () =>
      SETTINGS_MENU.filter(
        (item) =>
          item.path !== GENERAL_DATA_SHARING_PATH || canShowGeneralDataSharing,
      ),
    [canShowGeneralDataSharing],
  );

  const branchName = clinicDet?.name || profile?.name || "Clinic";
  const branchLocation = clinicDet?.location ? ` - ${clinicDet.location}` : "";

  const handleBack = () => {
    navigate("/clinic-consultation", { replace: true });
  };

  return (
    <div className="gs-root">
      <div className="gs-topbar">
        <div className="gs-topbar-left">
          <button
            type="button"
            className="gs-back-btn"
            onClick={handleBack}
            aria-label="Back"
          >
            <ArrowBackIcon sx={{ fontSize: 22, color: AppColors.white }} />
          </button>
          <div>
            <Typography className="gs-title">Global Settings</Typography>
            <Typography className="gs-subtitle">
              {branchName}
              {branchLocation}
            </Typography>
          </div>
        </div>
        {/* <div className="gs-topbar-right">
          <InfoOutlinedIcon sx={{ fontSize: 18, color: "#B8D4F0" }} />
          <Typography className="gs-info-text">
            Organization-wide defaults are managed by your Super Admin — this
            page controls only {clinicDet?.location || branchName}.
          </Typography>
        </div> */}
      </div>

      <div className="gs-body">
        <aside className="gs-sidebar">
          {visibleMenu.map((item) => (
            <NavLink
              key={item.path}
              to={item.path}
              className={({ isActive }) =>
                `gs-menu-item${isActive ? " gs-menu-item-active" : ""}`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </aside>

        <main className="gs-content">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default GlobalSettingsLayout;
